import * as accountApi from "./account.api";
import * as audioApi from "./audio.api";
import * as renderApi from "./render.api";
import * as brandApi from "./brand.api";

export const Apis = {
    audio: audioApi,
    account: accountApi,
    render: renderApi,
    brand: brandApi
}

export default Apis